import { useEffect, useState } from 'react';
import KeywordSlot from './KeywordSlot';
import KeywordOutput from './KeywordOutput';

const KeywordAssembler = (props) => {
    const colCount = parseInt(props.colCount) ?? 3;
    const initial = [];
    for (let i = 0; i < colCount; i++) {
        initial.push([]);
    }
    const [keywordsCols, setKeywordsCols] = useState(props.keywordsCols ?? initial);
    const [keywords, setKeywords] = useState([]);
    const [loadExample, setLoadExample] = useState(false);

    const exampleCols = [
        ['best', 'top rated', 'simple', 'fast', 'easy', 'free'],
        ['keyword'],
        ['builder', 'generator', 'mixer', 'combiner'],
        ['tool', 'software', 'site', 'page', 'app'],
        ['English', 'US', 'Canada', 'UK', 'Australia'],
    ];
    const exampleRequired = [false, true, true, false, false];

    const createKeywords = () => {
        let generatedKeywords = [];
        const sizes = keywordsCols.map(a => a.length);
        const indexes = new Array(sizes.length).fill(0);

        const moveIndex = () => {
            for (let i = indexes.length - 1; i >= 0; i--) {
                indexes[i]++;
                if (indexes[i] >= sizes[i]) {
                    if (i != 0) { indexes[i] = 0; }
                } else { break; }
            }
        }

        let keywordTotal = sizes.reduce((accum, n) => accum * (n == 0 ? 1 : n), 1);
        while (keywordTotal-- > 0) {
            let word = "";
            for (let i = 0; i < indexes.length; i++) {
                if (keywordsCols[i].length > indexes[i]) {
                    word = word + ' ' + keywordsCols[i][indexes[i]];
                }
            }
            const wordWithCleanSpacing = word.trim().replace(/\s+/g, ' ');
            if (wordWithCleanSpacing != '') {
                generatedKeywords.push(wordWithCleanSpacing);
            }
            moveIndex();
        }

        setKeywords(generatedKeywords);
    }

    const saveColumn = (col) => (content) => {
        setKeywordsCols((current) => {
            let newCols = [...current];
            newCols[col] = content;
            return newCols;
        });
    }

    const exactMatchKeywords = () => keywords.map(s => '[' + s + ']');
    const phraseMatchKeywords = () => keywords.map(s => '"' + s + '"');
    const broadMatchKeywords = () => keywords.map(s => '+' + s.replaceAll(' ', ' +'));

    const enableExample = () => setLoadExample(true);

    useEffect(() => { createKeywords(); }, [keywordsCols]);
    useEffect(() => { setLoadExample(false); }, [loadExample]);

    return (
        <div className="assembler">
            {keywords.length === 0 &&
                <button onClick={enableExample} className="example-btn">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="5 3 19 12 5 21 5 3"/>
                    </svg>
                    Load example
                </button>
            }
            <div className="columns-grid">
                {keywordsCols.map((col, idx) => (
                    <KeywordSlot
                        key={idx}
                        colIndex={idx + 1}
                        example={exampleCols[idx]}
                        exampleRequired={exampleRequired[idx]}
                        loadExample={loadExample && keywords.length === 0}
                        saveStatus={saveColumn(idx)}
                    />
                ))}
            </div>

            {keywords.length > 0 &&
                <div className="results-section">
                    <div className="results-header">
                        <h2 className="results-title">Generated Keywords</h2>
                        <span className="results-count">{keywords.length} combinations</span>
                    </div>
                    <div className="output-grid">
                        <KeywordOutput matchType="raw" label="Raw" format="keyword phrase" keywords={keywords} />
                        <KeywordOutput matchType="exact match" label="Exact Match" format="[keyword phrase]" keywords={exactMatchKeywords()} />
                        <KeywordOutput matchType="phrase match" label="Phrase Match" format={'"keyword phrase"'} keywords={phraseMatchKeywords()} />
                        <KeywordOutput matchType="broad match" label="Broad Match" format="+keyword +phrase" keywords={broadMatchKeywords()} />
                    </div>
                </div>
            }
        </div>
    );
}

export default KeywordAssembler;
